import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "optionPatient",
    "optionTemplate",
    "optionCopy",
    "patientWrapper",
    "patientSelect",
    "submitBtn"
  ]

  static values = {
    url: String
  }

  connect() {
    try {
      this.toggleOption()
    } catch(e) {
      console.error('Error in toggleOption:', e)
    }
  }

  toggleOption() {
    if (!this.hasOptionPatientTarget) {
      console.warn('optionPatient target not found')
      return
    }

    const isPatientSelected = this.optionPatientTarget.checked

    if (this.hasPatientWrapperTarget) {
      if (isPatientSelected) {
        this.patientWrapperTarget.style.display = 'block'
        this.patientWrapperTarget.style.opacity = '1'
      } else {
        this.patientWrapperTarget.style.display = 'none'
        this.patientWrapperTarget.style.opacity = '0.5'
      }
    }
  }

  duplicate(event) {
    event.preventDefault()

    const btn = event.currentTarget
    const baseUrl = this.urlValue

    if (!baseUrl) {
      console.error('URL value not set')
      alert('Error: URL no configurada')
      return
    }

    const params = new URLSearchParams()

    if (this.hasOptionPatientTarget && this.optionPatientTarget.checked) {
      if (!this.hasPatientSelectTarget) {
        console.error('Patient select target not found')
        return
      }
      const patientId = this.patientSelectTarget.value
      if (!patientId) {
        alert('Por favor selecciona un paciente')
        this.patientSelectTarget.focus()
        return
      }
      params.append('patient_id', patientId)
    } else if (this.hasOptionTemplateTarget && this.optionTemplateTarget.checked) {
      params.append('as_template', 'true')
    }
    // For "copy" option, no params needed - it will duplicate without patient

    // Show loading state
    btn.disabled = true
    btn.innerHTML = '<i class="fas fa-spinner fa-spin mr-1"></i> Duplicando...'

    // Create and submit form
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `${baseUrl}?${params.toString()}`

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    document.body.appendChild(form)
    form.submit()
  }
}
